module.exports = __webpack_public_path__ + "assets/img/0410.398097d9.png";